import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';


export const AffiliationsStyles = muiStyled(Box)(({ theme }) => ({
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    '.header-btns': {
        width: "100%",
        display: "flex",
        justifyContent: "end"
    }
}));

export const GradesStyles = muiStyled(Box)(({ theme }) => ({
}));

